import { YOUTUBE } from '@/lib/socialProfile';

export const networksNotAcceptedByScheduler = [YOUTUBE];
